import { useState, useMemo } from "react";
import styles from "./PaymentDetails.module.scss";
import CustomButton from "../../../../components/Button/CustomButton";
import EMIsAPI from "../../../../services/emi-api";
import { rozarLoanPayment, payULoanPayment } from "../../../../lib/payments";
import Swal from "sweetalert2";
import { Button, Drawer } from "@mui/material";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { PAYMENT_GATEWAY, SELECTED_PAYMENT_GATEWAY } from "../../../../Constants/constant";


export default function PaymentDetails({ amount }) {
  const [partPaymentAmount, setPartPaymentAmount] = useState("");
  const [paymentType, setPaymentType] = useState("full");
  const [sheetOpen, setSheetOpen] = useState(false);
  const api = useMemo(() => new EMIsAPI(), []);
  const initiatePaymentAPI = api.initiatePayment;

  const handlePaymentOrder = async (ptype) => {
    if(ptype === 'part') {
      if(partPaymentAmount < 100) {   
        Swal.fire({
            icon: "warning",
            text: "Input amount should be between ₹100 - ₹" + amount,
          });
          return;
      }
      if(partPaymentAmount > amount) {
        Swal.fire({
            icon: "warning",
            text: "Part payment amount cannot be greater than total amount ₹" + amount,
          });
          return;
      }
    }
    try {
      const finalAmountTopay = ptype === "full" ? amount : partPaymentAmount;
      const response = await initiatePaymentAPI(finalAmountTopay);
      setSheetOpen(false);
      localStorage.setItem(SELECTED_PAYMENT_GATEWAY, response?.data?.gateway);
      const gatewayResponse = response?.data?.gatewayResponse;
      response?.data?.gateway === PAYMENT_GATEWAY.PAYU ? await payULoanPayment(gatewayResponse
      ) : await rozarLoanPayment(gatewayResponse);
    } catch (error) {
      console.error("Payment failed:", error);
    }
  };

  const handlePartPaymentChange = (e) => {
    const amount = Number(e.target.value);
    setPartPaymentAmount(isNaN(amount) ? 0 : amount);
  }

  const amountLeft = useMemo(() => amount - partPaymentAmount, [amount, partPaymentAmount]);

  const offerText = `Just ₹${amountLeft} away from closing your loan. Pay full now and get a new loan of ₹${amount} instantly.`;

  const handlePayNow = () => {
    if (paymentType === "full") return handlePaymentOrder("full");
    setSheetOpen(true);
  };

  return (
    <div className={styles.paymentDetails}>
      <div
        className={`${styles.paymentList} ${paymentType === "full" ? styles.active : ""}`}
        onClick={() => setPaymentType("full")}
      >
        <div className={styles.titleBlock}>
          <div className={styles.radio}>
            <div />
          </div>
          <div className={styles.title}>Full Payment</div>
        </div>

        {paymentType === "full" && (
          <div className={styles.totalPayable}>
            <div>Total amount to pay</div>
            <div className={styles.paymentAmount}>₹{amount}</div>
          </div>
        )}
      </div>

      <div
        className={`${styles.paymentList} ${paymentType === "part" ? styles.active : ""}`}
        onClick={() => setPaymentType("part")}
      >
        <div className={styles.titleBlock}>
          <div className={styles.radio}>
            <div />
          </div>
          <div className={styles.title}>Part Payment</div>
        </div>

        {paymentType === "part" && (
          <>
            <div className={styles.totalPayable}>
              <div>Total amount to pay</div>
              <div className={styles.paymentAmount}>₹{amount}</div>
            </div>

            <div>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Part - Payment Amount"
                autoComplete="off"
                onChange={handlePartPaymentChange}
                onBlur={handlePartPaymentChange}
                onInput={(e) => (e.target.value = e.target.value.replace(/[^0-9]/g, ""))}
              />
              <div className={styles.amountLeft}>Amount left: ₹{amountLeft}</div>
            </div>
          </>
        )}
      </div>

      <div style={{ height: 100 }} />

      <div className={styles.bottomButton}>
        {/* <img src="/images/rozar-pay.png" alt="" /> */}
        <CustomButton text="Pay Now" onClick={handlePayNow} />
      </div>

      <Drawer
        anchor="bottom"
        open={sheetOpen}
        onClose={() => setSheetOpen(false)}
        sx={{
          "& .MuiDrawer-paper": {
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
            maxWidth: '480px',
            margin: 'auto',
          },
        }}

      >
        <Box sx={{ p: 3, textAlign: 'center' }}>
          {/* Row 1: icon */}
          <Box display="flex" alignItems="center" justifyContent="center" fontSize="2rem" sx={{ margin: 'auto', borderRadius: 99999, width: 64, height: 64, background: 'linear-gradient(to right bottom, rgb(74, 222, 128), rgb(59, 130, 246))' }}>
            💰
          </Box>

          {/* Row 2: title */}
          <Typography variant="h6" gutterBottom fontWeight={700}>
            Pay full loan and get a new loan instantly!
          </Typography>

          {/* Row 3: description with remaining and loan amount */}
          <Typography variant="body2" color="textSecondary" fontSize={'0.95rem'} sx={{ px: 2 }}>
            {offerText}
          </Typography>

          {/* Row 4: Pay button */}
          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
            <Button 
              variant="contained" 
              color="primary" 
              sx={{
                width: '100%',
                background: '#3b82f6',
                borderRadius: '25px',
                padding: '10px 30px',
                fontWeight: 'bold',
                textTransform: 'none',
                boxShadow: 'none',
                '&:hover': {
                  background: '#2563eb',
                  boxShadow: 'none',
                },
              }}
              onClick={async () => {
                setSheetOpen(false);
                await handlePaymentOrder('full');
              }}> 
              Pay Full & Get New Loan
            </Button>
          </Box>

          {/* Row 5: continue with part payment link */}
          <Box sx={{ mt: 2 }}>
            <Typography
              variant="body2"
              sx={{ textDecoration: 'underline', cursor: 'pointer' }}
              onClick={async () => {
                await handlePaymentOrder('part');
              }}
            >
              Continue with part payment
            </Typography>
          </Box>
        </Box>
      </Drawer>
    </div>
    
  );
}
